import { Button } from '@synergy-marine-group/synergy-ui';
import React from 'react';
import Modal from 'react-responsive-modal';
import { deleteModalStyles } from './styles';
import warningIcon from '../../images/icons/triangleExclamation.svg';

const ConfirmDuplicateCrewLineItem = ({ modal, setModal, onConfirm, onCancel }) => {
  const handleNo = () => {
    if (onCancel) {
      onCancel();
    }
    setModal(false);
  };

  const handleYes = () => {
    onConfirm();
    setModal(false);
  };

  return (
    <Modal
      open={modal}
      onClose={handleNo}
      closeOnOverlayClick={false}
      center
      showCloseIcon={false}
      styles={deleteModalStyles}
    >
      <div className="w-auto py-8 px-8 font-muli">
        <div className="text-center">
          <h2 className="uppercase font-montserrat pb-4 font-bold flex items-center justify-center gap-2">
            <img className="w-6 h-6" src={warningIcon} alt="warning" />
            Warning
          </h2>
          <p className="font-normal text-center">
            A combination of Crew Code and Expense Line Item already exists in the list.
          </p>
          <p className="font-normal pb-6 text-center">
            Do you want to proceed?
          </p>
          <div className="flex justify-center items-center gap-4">
            <Button
              className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
              onClick={handleNo}
              size="large"
              variant="outlined"
              rounded
            >
              No
            </Button>
            <Button
              className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
              onClick={handleYes}
              size="large"
              variant="filled"
              rounded
            >
              Yes
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDuplicateCrewLineItem;
